import React, { useRef } from "react";
import { RelationTypeItem } from "./RelationTypeItem";
import { Card } from "../../../../common";
import useScreenSize from "../../../../../Hooks/useScreenSize";
export const TaxDetails = ({ companyTaxDetails }) => {
  const containerCarousel = useRef(null);
  const { isMobile, isTablet, isDesktop } = useScreenSize();

  const btnPressPrev = () => {
    if (containerCarousel.current) {
      const containerWidth = containerCarousel.current.offsetWidth;
      containerCarousel.current.scrollLeft -= containerWidth;
    }
  };

  const btnPressNext = () => {
    if (containerCarousel.current) {
      const containerWidth = containerCarousel.current.offsetWidth;
      containerCarousel.current.scrollLeft += containerWidth;
    }
  };
  return (
    <Card classes="rounded-xl bg-white p-6 mb-6">
      <div>
        <h3 className="text-start text-f18 font-semibold">Tax Information</h3>
      </div>
      <div className="rounded-xl sm:grid grid-cols-3 gap-4 containerCarousel p-2 flex overflow-x-hidden scroll-smooth" ref={containerCarousel}>
        {companyTaxDetails.map((tax) => (
          tax?.is_deleted == 0 &&
          <RelationTypeItem
            name={tax?.categoryTitle}
            country={``}
            type={"Tax Number"}
            typeValue={tax?.tax_reg_no}
            document={tax?.upload_file}
          />
        ))}
      </div>
      {isMobile && <div className="carousel_box relative overflow-hidden p-4">
        <button className="pre-btn rotate-180" onClick={btnPressPrev}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="21"
            viewBox="0 0 20 21"
            fill="none"
          >
            <path
              d="M3.33301 10.5H16.6663M16.6663 10.5L11.6663 5.5M16.6663 10.5L11.6663 15.5"
              stroke="#2C5369"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
        <button className="next-btn" onClick={btnPressNext}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="21"
            viewBox="0 0 20 21"
            fill="none"
          >
            <path
              d="M3.33301 10.5H16.6663M16.6663 10.5L11.6663 5.5M16.6663 10.5L11.6663 15.5"
              stroke="#2C5369"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
      </div>}
    </Card>
  );
};
